export const tourcoingPostalCode = ['59200'];
